import {
  inject,
  provide,
  ref,
  computed,
  type Ref,
  type InjectionKey,
} from 'vue';

export { createFeedback, useFeedback };
export type { FeedbackProps, FeedbackStore };

interface FeedbackProps {
  type: 'success' | 'error';
  heading: string;
  supplement?: string;
}
type FeedbackStore = ReturnType<typeof createFeedback>;
const FeedbackKey: InjectionKey<FeedbackStore> = Symbol('FeedbackStore');

function createFeedback() {
  const privateProps: Ref<Required<FeedbackProps> | null> = ref(null);
  const props = computed(() => privateProps.value);
  const funcId: Ref<number | null> = ref(null);

  const pushFeedback = (newFeedback: FeedbackProps) => {
    privateProps.value = {
      type: newFeedback.type,
      heading: newFeedback.heading,
      supplement: newFeedback.supplement ?? '',
    };
    if (funcId.value) clearTimeout(funcId.value);
    funcId.value = window.setTimeout(() => {
      privateProps.value = null;
      funcId.value = null;
    }, 3 * 1000);
  };

  const store = {
    props,
    pushFeedback,
  };
  provide(FeedbackKey, store);
  return store;
}

function useFeedback() {
  return inject(FeedbackKey) as FeedbackStore;
}
